import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import {
  Icon,
  Button,
  makeStyles,
  Paper,
  CircularProgress,
} from '@material-ui/core';
import FormikField from '../FormikField';
import { useStateAuthValue } from '../context/Auth/AuthState';
import { loginUtilGallion } from '../utils/LoginUtil';
import { useToast } from '../context/Toast/ToastProvider';
import { showToast, ToastType } from '../utils/ToastUtil';
import clickSound from "../assets/notifications/click.mp3" 
import { useProfessionalLogState } from '../context/profesionalPage/professionalLog/professionalLogState';

const useStyles = makeStyles((theme) => ({
  submit: {
    backgroundColor: '#DA2037',
    '&:hover': {
      backgroundColor: '#e84353',
    },
    margin: theme.spacing(3, 0, 2),
    borderRadius: '20px',
    textTransform: 'capitalize',
  },
  btnSecondary: {
    backgroundColor: '#002C54',
    '&:hover': {
      backgroundColor: '#003f77',
    },
    margin: theme.spacing(0, 0, 4),
    borderRadius: '20px',
    textTransform: 'capitalize',
  },
  visibility: {
    color: '#DA2037',
  },
  paperForm: {
    padding: '20px',
  },
  txtForgotPass: {
    margin: theme.spacing(-2, 0, 1),
    textTransform: 'capitalize',
    width: '100%',
    alignSelf: 'center',
    textAlign: 'center',
  },
}));

const initialValuesLogin = {
  idNumber: '',
  policyNumber: '',
};

const LoginScheme = Yup.object().shape({
  idNumber: Yup.string().required('DNI Requerido'),
  policyNumber: Yup.string().required('Número de póliza requerido'),
});

export default function AuthFormLoginGallion() {
  const history = useHistory();
  const classes = useStyles();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [, dispatch] = useStateAuthValue();
  const [, dispatchProfessionalLog = dispatch] = useProfessionalLogState();
  const toastDispatch = useToast();

  async function handleSubmitLogin(values, { setSubmitting: setFormikSubmitting }) {
    setIsSubmitting(true);
    setFormikSubmitting(true);
    const audio = new Audio(clickSound);
    audio.addEventListener('canplaythrough', () => {
      audio.play();
    });
    const displayError = (msg) =>
      showToast(toastDispatch, msg, ToastType.ERROR, ToastType.ERROR);

    await loginUtilGallion(
      values,
      dispatch,
      dispatchProfessionalLog,
      history,
      (value) => {
        setIsSubmitting(value);
        setFormikSubmitting(value);
      },
      displayError
    );

    // setIsSubmitting(false);
    // setFormikSubmitting(false);
  }

  return (
    <Formik
      initialValues={initialValuesLogin}
      onSubmit={handleSubmitLogin}
      validationSchema={LoginScheme}
    >
      {({ dirty, isValid }) => {
        return (
          <Form>
            <Paper elevation={3} className={classes.paperForm}>
              <FormikField name="idNumber" label="DNI" />
              <FormikField name="policyNumber" label="Número de póliza" />
            </Paper>
            <Button
              disabled={isSubmitting || !(isValid && dirty)}
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              endIcon={
                isSubmitting ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  <Icon>chevron_right</Icon>
                )
              }
            >
              {isSubmitting ? 'Ingresando...' : 'Ingresar'}
            </Button>
          </Form>
        );
      }}
    </Formik>
  );
}
